/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Where this carrier's prices landed on the boards their customers saw.
 *
 * No dollar figures, by design: a carrier knows its own rate, so showing
 * our price on it would reveal our markup exactly. No other carrier is
 * identifiable here either — a carrier may see its own position, never the
 * leaderboard.
 *
 * Every rate is omitted rather than zero when its denominator is empty.
 * Zero would read as "you're never cheapest" when the truth is that we
 * have nothing to go on yet.
 *
 * @export
 * @interface PerformanceCompetitiveness
 */
export interface PerformanceCompetitiveness {
  /**
   * Distinct shipments this carrier priced. This is the win-rate
   * denominator — always shown alongside it, because low volumes
   * produce wild rates.
   *
   * @type {number}
   * @memberof PerformanceCompetitiveness
   */
  quotedShipments: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceCompetitiveness
   */
  wonShipments: number;
  /**
   * Share of quoted shipments where they held the lowest price shown.
   * @type {number}
   * @memberof PerformanceCompetitiveness
   */
  cheapestRate?: number;
  /**
   * 1 = cheapest. Lower is better.
   * @type {number}
   * @memberof PerformanceCompetitiveness
   */
  averagePriceRank?: number;
  /**
   * Typical number of carriers on the board. A rank of 3 means something
   * different against 12 carriers than against 3.
   *
   * @type {number}
   * @memberof PerformanceCompetitiveness
   */
  averageCarriersQuoting?: number;
  /**
   * When not cheapest, how far above the lowest price they sat, as a
   * fraction — 0.15 is 15% above.
   *
   * @type {number}
   * @memberof PerformanceCompetitiveness
   */
  averagePremiumWhenNotCheapest?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceCompetitiveness
   */
  winRateWhenCheapest?: number;
  /**
   * Above zero means freight won on something other than price.
   *
   * @type {number}
   * @memberof PerformanceCompetitiveness
   */
  winRateWhenNotCheapest?: number;
  /**
   * Share of everything the platform quoted that this carrier priced at
   * all. Measures coverage, not competitiveness.
   *
   * @type {number}
   * @memberof PerformanceCompetitiveness
   */
  participation?: number;
}

/**
 * Check if a given object implements the PerformanceCompetitiveness interface.
 */
export function instanceOfPerformanceCompetitiveness(
  value: object,
): value is PerformanceCompetitiveness {
  if (!("quotedShipments" in value) || value["quotedShipments"] === undefined)
    return false;
  if (!("wonShipments" in value) || value["wonShipments"] === undefined)
    return false;
  return true;
}

export function PerformanceCompetitivenessFromJSON(
  json: any,
): PerformanceCompetitiveness {
  return PerformanceCompetitivenessFromJSONTyped(json, false);
}

export function PerformanceCompetitivenessFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceCompetitiveness {
  if (json == null) {
    return json;
  }
  return {
    quotedShipments: json["quotedShipments"],
    wonShipments: json["wonShipments"],
    cheapestRate:
      json["cheapestRate"] == null ? undefined : json["cheapestRate"],
    averagePriceRank:
      json["averagePriceRank"] == null ? undefined : json["averagePriceRank"],
    averageCarriersQuoting:
      json["averageCarriersQuoting"] == null
        ? undefined
        : json["averageCarriersQuoting"],
    averagePremiumWhenNotCheapest:
      json["averagePremiumWhenNotCheapest"] == null
        ? undefined
        : json["averagePremiumWhenNotCheapest"],
    winRateWhenCheapest:
      json["winRateWhenCheapest"] == null
        ? undefined
        : json["winRateWhenCheapest"],
    winRateWhenNotCheapest:
      json["winRateWhenNotCheapest"] == null
        ? undefined
        : json["winRateWhenNotCheapest"],
    participation:
      json["participation"] == null ? undefined : json["participation"],
  };
}

export function PerformanceCompetitivenessToJSON(
  json: any,
): PerformanceCompetitiveness {
  return PerformanceCompetitivenessToJSONTyped(json, false);
}

export function PerformanceCompetitivenessToJSONTyped(
  value?: PerformanceCompetitiveness | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    quotedShipments: value["quotedShipments"],
    wonShipments: value["wonShipments"],
    cheapestRate: value["cheapestRate"],
    averagePriceRank: value["averagePriceRank"],
    averageCarriersQuoting: value["averageCarriersQuoting"],
    averagePremiumWhenNotCheapest: value["averagePremiumWhenNotCheapest"],
    winRateWhenCheapest: value["winRateWhenCheapest"],
    winRateWhenNotCheapest: value["winRateWhenNotCheapest"],
    participation: value["participation"],
  };
}
